export default "__VITE_ASSET__DJaXgShk__"